<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="padding-left-custom-title">
          <span class="uppercase title-app__custom-about">contact</span>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="py-0">
      <v-row class="pl-3">
        <v-col cols="12" md="3">
          <div>
            <span class="uppercase d-block bold">{{customContactSingleton.field_1.text}}</span>
            <a
              :href="'mailto:'+customContactSingleton.field_1.email"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block">{{customContactSingleton.field_1.email}}</span>
            </a>
          </div>

          <div class="mt-5">
            <span class="uppercase d-block bold">{{customContactSingleton.field_2.text}}</span>
            <a
              :href="'mailto:'+customContactSingleton.field_2.phone"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block">{{customContactSingleton.field_2.phone}}</span>
            </a>
          </div>

          <div class="mt-5 width-fit-content">
            <router-link :to="customContactSingleton.field_3.link" class="not-text-decoration">
              <span class="link-worshop gtAmerica-bold">
                {{customContactSingleton.field_3.text}}
                <div class="animation-line"></div>
              </span>
            </router-link>
          </div>

          <div class="mt-10 margin-div-mobile">
            <div
              v-for="(network, nt) in socialNetworks"
              :key="nt"
              class="d-inline-block social-separation"
            >
              <template v-if="width >= 2300">
                <template v-if="width >= 3500">
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="75"></v-img>
                  </a>
                </template>
                <template v-else>  
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="50"></v-img>
                  </a>
                </template>
              </template>
              <template v-else>
                <a :href="network.link" target="_blank">
                  <v-img :src="network.image"></v-img>
                </a>
              </template>
            </div>
          </div>

          <div class="margin-div-custom">
            <a
              :href="customContactSingleton.field_4.link"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block">
                <span class="gtAmerica-bold">{{customContactSingleton.field_4.text}}</span>
                <!-- <br />2830 Glenoaks Canyon Dr
                <br />Glendale CA 91206 -->
              </span>
            </a>

            <a
              :href="customContactSingleton.field_5.link"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block mt-5">
                <span class="gtAmerica-bold">{{customContactSingleton.field_5.text}}</span>
                <br />3011 N Main Street
                <br />Los Angeles, CA 90031
              </span>
            </a>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div v-for="(person, pr) in customContactSingleton.person" v-bind:key="pr" class="mb-2">
            <span class="uppercase gtAmerica-bold d-block">{{person.value.position}}</span>
            <span class="d-block capitalize">{{person.value.name}}</span>
            <a :href="'mailto:'+person.value.email" target="_blank" class="not-text-decoration">
              <span class="d-block">{{person.value.email}}</span>
            </a>

            <template v-if="person.value.phone != null">
              <a :href="'tel:'+person.value.phone" target="_blank" class="not-text-decoration">
                <span class="d-block">{{person.value.phone}}</span>
              </a>
            </template>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-md-0">
            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+customContactSingleton.cover.path" height="100%" class="text-center align-end d-none d-md-flex"><span class="national-medium white--text pb-6 d-block" style="font-size: 42px">ARTLESS is after the timeless</span></v-img>

            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+customContactSingleton.cover.path" width="100%" class="text-center align-end d-md-none"><span class="national-medium white--text pb-6 d-block" style="font-size: 22px">ARTLESS is after the timeless</span></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import instagram from "@/assets/img/icons/instagram.svg";
import pinterest from "@/assets/img/icons/pinterest.svg";
export default {
  data() {
    return {
      customContactSingleton: {},
      socialNetworks: [
        
        {
          link: "https://www.instagram.com/artlesscustom/",
          image: instagram,
        },
        {
          link: "https://www.pinterest.com.mx/artlesscorp/_created/",
          image: pinterest,
        },
      ],
    };
  },
  beforeMount() {
    //fetch to get the singleton "custom-contact"
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/singletons/get/CustomContact?token=a15be93e9cdb43ca2b3778c2077c26"
    )
      .then((data) => data.json())
      .then((data) => (this.customContactSingleton = data));
  },
  mounted() {
    var breadcrumbs = [
      {
          text: 'Home',
          link: '/',
          isLink: true
      },
      {
          text: 'Custom',
          link: '/custom',
          isLink: true
      },
      {
          text: 'Contact',
          link: '/custom/contact',
          isLink: false
      }
    ];
    this.$emit("updateStatus", breadcrumbs);
    this.$emit("update", 2);
    gtag('config', 'UA-26953667-1', {
    'page_title' : 'Custom Contact',
    'page_path': '/custom/contact'
    });
  },
};
</script>